<template>
    <div class="shop-cart">
        <div class="cart">
            <van-badge :content="state.cartNum">
                <van-icon
                    class="child"
                    name=" iconfont d-shop-unchecked-cart"
                />
            </van-badge>
        </div>
        <shop-cart-balls ref="ball"></shop-cart-balls>
    </div>
</template>

<script>
import { reactive } from "vue";
import ShopCartBalls from "./ShopCartBalls";
import { Badge } from "vant";
import { addCart, getCartList } from "@/api/shopApi";
export default {
    name: "ShopCart",
    props: {
        id: {
            type: String,
            default: "",
        },
    },
    components: {
        ShopCartBalls,
        [Badge.name]: Badge,
    },
    setup() {
        const state = reactive({
            cartNum: null,
        });
        return { state };
    },
    async mounted() {
        this.getCartNum();
    },
    methods: {
        drop(target,item) {
            this.$refs.ball.drop(target);
            // this.state.cartNum ++;
          this.addCart(item.id);
            this.getCartNum();
        },
        async addCart(productId) {
            const params = {
                productId: productId,
                num: 1,
            };
            await addCart(params);
        },
        async getCartNum() {
            const res = await getCartList();
            this.state.cartNum = res.totalNum;
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.van-badge__wrapper) {
    z-index: 1;
}
</style>
